import React from 'react';
import Chart from 'react-apexcharts';

const formatMinutesToHHMM = (minutes) => {
  const hours = Math.floor(minutes / 60);
  const mins = Math.round(minutes % 60);
  return `${hours.toString().padStart(2, '0')}h ${mins.toString().padStart(2, '0')}m`;
};

function WeeklyLineChart({ weeklyData }) {
  const reversed = [...weeklyData].reverse();

  const chartOptions = {
    chart: {
      id: 'weekly-intelli-line',
      type: 'line',
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    xaxis: {
      categories: reversed.map((week) =>
        new Date(week.weekStartDate).toLocaleDateString('en-US', {
          month: 'short',
          day: 'numeric',
          year: 'numeric',
        })
      ),
       title: {
        text: 'Weeks',
      },
      labels: {
        rotate: -45,
        style: { fontSize: '12px' },
      },
    },
    yaxis: {
      labels: {
        formatter: (val) => formatMinutesToHHMM(val),
      },
      title: {
        text: 'Duration',
      },
    },
    stroke: {
      curve: 'smooth',
      width: 4,
      // For gradient, use 'colors' in series instead of chart options
    },
    markers: {
      size: 5,
    },
    fill: {
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'horizontal',
        shadeIntensity: 0.5,
        gradientToColors: ['#9b5ce8ff'], // green
        inverseColors: false,
        opacityFrom: 1,
        opacityTo: 1,
        stops: [0, 100],
      },
    },
    tooltip: {
      y: {
        formatter: (val) => formatMinutesToHHMM(val),
      },
    },
    title: {
      text: '',
      align: 'center',
      style: { fontSize: '12px', fontWeight: 'bold' },
    },
  };

  const chartSeries = [
    {
      name: 'ON Duration',
      data: reversed.map((week) => parseFloat(week.totalMinutes.toFixed(2))),
      color: '#ff8949ff', // fallback line color
    },
  ];

  return (
    <div>
      <Chart options={chartOptions} series={chartSeries} type="line" height={300} />
    </div>
  );
}

export default WeeklyLineChart;
